import request from '@/utils/request'

export function getProductByCode(code) {
  return request({
    url: 'product/getProductByCode/' + code,
    method: 'get'
  });
}
